import React, { useState } from "react";

const PartnershipApplication = () => {
  const [formData, setFormData] = useState({
    serverName: "",
    ownerName: "",
    discordTag: "",
    serverIP: "",
    serverType: "",
    playerCount: "",
    websiteURL: "",
    whyPartner: "",
  });

  const [status, setStatus] = useState({ message: "", type: "" });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const webhookURL =
      "https://discord.com/api/webhooks/1375126693420863628/9rGWMdI5JR2Rhj70NYolOwBY6tBvXNxS7fSbzt4r4RM3KK7mctR7ErjgTPrMjmE8m0f0";

    const embed = {
      embeds: [
        {
          title: "🤝 Partnership Application",
          color: 0x5865f2,
          fields: [
            { name: "Server/Channel Name", value: formData.serverName || "N/A" },
            { name: "Owner/Contact Person", value: formData.ownerName || "N/A" },
            { name: "Discord Tag", value: formData.discordTag || "N/A" },
            { name: "Server IP or Link", value: formData.serverIP || "N/A" },
            { name: "Server Type", value: formData.serverType || "N/A" },
            { name: "Player/Viewer Count", value: formData.playerCount || "N/A" },
            { name: "Website/Social Link", value: formData.websiteURL || "N/A" },
            { name: "Why Partner?", value: formData.whyPartner || "N/A" },
          ],
          footer: {
            text: "RixxyMC Partnership System",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(embed),
      });

      if (!response.ok) throw new Error("Failed to send application.");

      setStatus({
        message: "✅ Partnership application submitted successfully!",
        type: "success",
      });

      setFormData({
        serverName: "",
        ownerName: "",
        discordTag: "",
        serverIP: "",
        serverType: "",
        playerCount: "",
        websiteURL: "",
        whyPartner: "",
      });
    } catch (err) {
      setStatus({
        message: "❌ Submission failed. Please try again later.",
        type: "error",
      });
    }
  };

  return (
    <div className="container">
      <h2>Partnership Application</h2>
      <p>Apply for a partnership with RixxyMC.</p>

      {status.message && (
        <div style={{ marginTop: "1rem", color: status.type === "success" ? "green" : "red" }}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="serverName">Server or Channel Name:</label>
        <input
          type="text"
          id="serverName"
          value={formData.serverName}
          onChange={handleChange}
          placeholder="Name of your server or channel"
          required
        />

        <label htmlFor="ownerName">Owner or Contact Person:</label>
        <input
          type="text"
          id="ownerName"
          value={formData.ownerName}
          onChange={handleChange}
          placeholder="Your name"
          required
        />

        <label htmlFor="discordTag">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discordTag"
          value={formData.discordTag}
          onChange={handleChange}
          placeholder="Your Discord tag"
          required
        />

        <label htmlFor="serverIP">Server IP or Link (if applicable):</label>
        <input
          type="text"
          id="serverIP"
          value={formData.serverIP}
          onChange={handleChange}
          placeholder="IP address or invite link"
        />

        <label htmlFor="serverType">Type of Server/Channel:</label>
        <input
          type="text"
          id="serverType"
          value={formData.serverType}
          onChange={handleChange}
          placeholder="e.g., Minecraft, Discord, YouTube"
          required
        />

        <label htmlFor="playerCount">Average Player/Viewer Count:</label>
        <input
          type="number"
          id="playerCount"
          value={formData.playerCount}
          onChange={handleChange}
          placeholder="Approximate number"
          min="0"
        />

        <label htmlFor="websiteURL">Website or Social Media URL (optional):</label>
        <input
          type="url"
          id="websiteURL"
          value={formData.websiteURL}
          onChange={handleChange}
          placeholder="Website or social link"
        />

        <label htmlFor="whyPartner">Why do you want to partner with RixxyMC?</label>
        <textarea
          id="whyPartner"
          rows="4"
          value={formData.whyPartner}
          onChange={handleChange}
          placeholder="Tell us why we should partner"
          required
        ></textarea>

        <button type="submit">Submit Application</button>
      </form>
    </div>
  );
};

export default PartnershipApplication;
